import React, { FC } from 'react';
import useReactRouter from 'use-react-router';
import { firebase_db, firebase_auth } from './config/firebase';
import {validate} from './misc'
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {Copyright} from './material/copywrite'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Alert from './material/alert'

const inversion_nums = [
  {
    value: '0',
    label: '０回',
  },
  {
    value: '1',
    label: '１回',
  },
  {
    value: '2',
    label: '２回',
  },
  {
    value: '3',
    label: '３回',
  },
  {
    value: '4',
    label: '４回',
  },
  {
    value: '5',
    label: '５回',
  },
];

const inversion_intervals = [
  {
    value: '20',
    label: '２０手',
  },
  {
    value: '40',
    label: '４０手',
  },
  {
    value: '60',
    label: '６０手',
  },
  {
    value: '80',
    label: '８０手',
  },
  {
    value: '100',
    label: '１００手',
  },
  {
    value: '120',
    label: '１２０手',
  },
  {
    value: '140',
    label: '１４０手',
  },
];


const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  paperSub: {
    marginTop: theme.spacing(2),
    // marginLeft: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontWeight: 'bold',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  root: {
    '& .MuiTextField-root': {
      // margin: theme.spacing(2),
      width: 120,
    },
  },
}));

export const Auth: FC = () =>  {
  const [name, setName] = React.useState('');
  const [name_invalid, setNameInvalid] = React.useState(false);
  const [name_helper, setNameHelper] = React.useState('');
  const [turn, setTurn] = React.useState('random');
  const [inversion_turn, setInversionTurn] = React.useState('me');
  const [inversion_num, setInversionNum] = React.useState('2');
  const [inversion_interval, setInversionInterval] = React.useState('40');
  const [room, setRoom] = React.useState('');
  const [room_invalid, setRoomInvalid] = React.useState(false);
  const [room_helper, setRoomHelper] = React.useState('');
  const [make_room_invalid, setMakeRoomInvalid] = React.useState(false);
  const [enter_room_invalid, setEnterRoomInvalid] = React.useState(false);
  const classes = useStyles();

  firebase_auth.signInAnonymously().catch(function() {
    // Handle Errors here.
  });
  let user = firebase_auth.currentUser;
  let uid = "";
  if(user){
    uid = user.uid;
  }

  const { history } = useReactRouter();

  const make_room_id = () => {
    let chars = "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".split("");
    for (let i = 0, len = chars.length; i < len; i++) {
      switch (chars[i]) {
        case "x":
          chars[i] = Math.floor(Math.random() * 16).toString(16);
            break;
        case "y":
          chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
          break;
      }
    }
    return chars.join("");
  }

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName((event.target as HTMLInputElement).value);
  };

  const handleTurnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTurn((event.target as HTMLInputElement).value);
  };

  const handleInversionTurnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInversionTurn((event.target as HTMLInputElement).value);
  };

  const handleInversionNumChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInversionNum(event.target.value);
  };

  const handleInversionIntervalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInversionInterval(event.target.value);
  };

  const handleMakeRoom = () => {
    if(!validate("name", name)){
      setNameInvalid(true);
      setNameHelper('半角英数字を1～10文字入力してください');
      return;
    }
    if(uid.length === 0){
      setMakeRoomInvalid(true);
      return;
    }
    let room_id = make_room_id();
    // 部屋が存在しないかチェック
    firebase_db.ref(`room/${room_id}/host`).once("value", function(snapshot){
      if(!snapshot.exists()){
        let turn_sub: boolean = true;
        if(turn === "random"){
          let random = Math.floor( Math.random() * 2 );
          if(random === 0){
            turn_sub = false;
          }
        }
        else if(turn === "white"){
          turn_sub = false;
        }
        let path = (turn_sub ? "black" : "white");
        let inversion_turn_sub = (inversion_turn === "me" ? turn_sub : !turn_sub);
        firebase_db.ref(`room/${room_id}/host`).set({uid});
        firebase_db.ref(`room/${room_id}/${path}`).set({
          uid: uid,
          name: name,
        });
        firebase_db.ref(`room/${room_id}/inversion`).set({
          turn: inversion_turn_sub,
          num: parseInt(inversion_num),
          interval: parseInt(inversion_interval),
        });
        history.push(`/room/${room_id}/${path}`);
      }
      else{
        setMakeRoomInvalid(true);
        return;
      }
    });
  }

  const handleRoomChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRoom((event.target as HTMLInputElement).value);
  };

  const handleEnterRoom = () => {
    if(!validate("name", name)){
      setNameInvalid(true);
      setNameHelper('半角英数字を1～10文字入力してください');
      return;
    }
    if(!validate("room_id", room)){
      setRoomInvalid(true);
      setRoomHelper('部屋IDの形式が違います');
      return;
    }
    if(uid.length === 0){
      setEnterRoomInvalid(true);
      return;
    }
    // 部屋が存在するかチェック
    firebase_db.ref(`room/${room}/host`).once("value", function(snapshot){
      if(snapshot.exists()){
        // 空いている手番の確認
        firebase_db.ref(`room/${room}/black`).once("value", function(snapshot2){
          if(!snapshot2.exists()){
            let path = "black";
            firebase_db.ref(`room/${room}/${path}`).set({
              uid: uid,
              name: name,
            });
            history.push(`/room/${room}/${path}`);
            return;
          }
          firebase_db.ref(`room/${room}/white`).once("value", function(snapshot3){
            if(!snapshot3.exists()){
              let path = "white";
              firebase_db.ref(`room/${room}/${path}`).set({
                uid: uid,
                name: name,
              });
              history.push(`/room/${room}/${path}`);
            }
            else{
              setEnterRoomInvalid(true);
              return;
            }
          });
        });
      }
      else{
        setEnterRoomInvalid(true);
        return;
      }
    });
  }

  const handleMakeClose = () => {
    setMakeRoomInvalid(false);
  }

  const handleEnterClose = () => {
    setEnterRoomInvalid(false);
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <h1 className={classes.paperSub}>
        反転将棋
      </h1>
      {/* <Typography component="h1" variant="h2">
        反転将棋
      </Typography> */}
      <div className={classes.paper}>
        <form className={classes.form} noValidate>
          <TextField
            error={name_invalid}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="name"
            label="ユーザ名"
            name="name"
            value={name}
            onChange={handleNameChange}
            autoComplete="name"
            helperText={name_helper}
            autoFocus
          />
        <hr></hr>
        </form>
        <FormControl component="fieldset">
          <FormLabel component="legend">手番</FormLabel>
            <RadioGroup aria-label="turn" name="turn" value={turn} onChange={handleTurnChange} row>
              <FormControlLabel
                value="black"
                control={<Radio color="primary" />}
                label="先手"
                labelPlacement="bottom"
              />
              <FormControlLabel
                value="white"
                control={<Radio color="primary" />}
                label="後手"
                labelPlacement="bottom"
              />
              <FormControlLabel
                value="random"
                control={<Radio color="primary" />}
                label="振り駒"
                labelPlacement="bottom"
              />
            </RadioGroup>
        </FormControl>
        &nbsp;
        <form className={classes.root} noValidate autoComplete="off">
          <div>
            <FormControl component="fieldset">
              <FormLabel className={classes.root} component="legend">反転できる手番</FormLabel>
              <RadioGroup aria-label="inversion_turn" name="inversion_turn" value={inversion_turn} onChange={handleInversionTurnChange} row>
                <FormControlLabel
                  value="me"
                  control={<Radio color="primary" />}
                  label="あなた"
                  labelPlacement="bottom"
                />
                <FormControlLabel
                  value="you"
                  control={<Radio color="primary" />}
                  label="相手"
                  labelPlacement="bottom"
                />
              </RadioGroup>
            </FormControl>
            <TextField
              id="standard-select-currency"
              select
              label="反転回数"
              value={inversion_num}
              onChange={handleInversionNumChange}
              style = {{width: 100}}
              // helperText="Please select your currency"
            >
              {inversion_nums.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
              ))}
            </TextField>
            &nbsp;
            <TextField
              id="standard-select-currency"
              select
              label="反転間隔"
              value={inversion_interval}
              onChange={handleInversionIntervalChange}
              style = {{width: 100}}
            >
              {inversion_intervals.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
              ))}
            </TextField>
          </div>
        </form>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={handleMakeRoom}
        >
          部屋を作る
        </Button>
      </div>
      <hr></hr>
      <form className={classes.form} noValidate>
        <TextField
          error={room_invalid}
          variant="outlined"
          margin="normal"
          fullWidth
          id="room"
          label="部屋ID"
          name="room"
          value={room}
          onChange={handleRoomChange}
          helperText={room_helper}
        />
      </form>
      <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={handleEnterRoom}
        >
          部屋に入る
      </Button>
      <hr></hr>
      <Box mt={8}>
        <Copyright />
      </Box>
      <Alert
        title={"部屋作りに失敗しました"}
        message={"再度部屋を作ると上手くいくことがあります。"}
        open={make_room_invalid}
        handleClose={handleMakeClose}
      />
      <Alert
        title={"入室できません"}
        message={"部屋が存在しないか、すでに対局者の募集が終了しています。"}
        open={enter_room_invalid}
        handleClose={handleEnterClose}
      />
    </Container>
  );
}
